import type { BoardBackgroundQuery } from './BoardBackgroundQuery.generated';

export const BOARD_THEME_DARK = 'board-theme-dark';
export const BOARD_THEME_LIGHT = 'board-theme-light';

export interface BoardThemeVariables {
  theme: typeof BOARD_THEME_DARK | typeof BOARD_THEME_LIGHT;
  dynamicBackgroundColor: string;
  dynamicBackgroundColorTransparent?: string;
  dynamicButtonBackgroundColor: string;
  dynamicButtonBackgroundColorHovered: string;
  dynamicButtonBackgroundColorPressed: string;
  dynamicNavItemBackgroundColorHovered: string;
  dynamicNavItemBackgroundColorPressed: string;
  dynamicIconColor: string;
  dynamicTextColor: string;
  dynamicTextColorTransparent: string;
}

export type DynamicVariables = Omit<BoardThemeVariables, 'theme'>;

export const DynamicTokenMap = {
  dynamicBackgroundColor: '--dynamic-background-color',
  dynamicBackgroundColorTransparent: '--dynamic-background-color-transparent',
  dynamicButtonBackgroundColor: '--dynamic-button-background-color',
  dynamicButtonBackgroundColorHovered:
    '--dynamic-button-background-color-hovered',
  dynamicButtonBackgroundColorPressed:
    '--dynamic-button-background-color-pressed',
  dynamicNavItemBackgroundColorHovered:
    '--dynamic-nav-item-background-color-hovered',
  dynamicNavItemBackgroundColorPressed:
    '--dynamic-nav-item-background-color-pressed',
  dynamicIconColor: '--dynamic-icon-color',
  dynamicTextColor: '--dynamic-text-color',
  dynamicTextColorTransparent: '--dynamic-text-color-transparent',
} as const;

export type BoardPrefs = NonNullable<BoardBackgroundQuery['board']>['prefs'];
export type BackgroundBrightness = NonNullable<BoardPrefs>['backgroundBrightness'];
